/**
 * /tenants/$slug/agents/decision-reports — Reported decisions (AI Agents → Agent governance → Activity).
 * The operator triage inbox: decisions a data-subject flagged as wrong from their Agent activity page.
 * Thin shim; the page fetches on mount (a low-traffic inbox, a brief skeleton is fine).
 */

import { createFileRoute } from "@tanstack/react-router";
import { DecisionReportsPage } from "@/features/decision-reports/pages/decision-reports-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/decision-reports")({
  component: DecisionReportsPage,
});
